module.exports = __webpack_public_path__ + "img/banner.5efdbee2.png";